var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cmp-wrapper"},[_c('div',{staticClass:"rad-row"},[_c('basic-container',[_c('div',{attrs:{"slot":"header-left"},slot:"header-left"},[_vm._v("饼加环")]),_c('pie-chart')],1),_c('basic-container',[_c('div',{attrs:{"slot":"header-left"},slot:"header-left"},[_vm._v("环")]),_c('ring-chart')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }